export const markdownText = `# Руководство по Markdown

## Основное форматирование текста

*Курсив*:
\`*текст*\` или \`_текст_\` → *текст*

**Жирный**:
\`**текст**\` или \`__текст__\` → **текст**

***Жирный курсив***:
\`***текст***\` или \`___текст___\` → ***текст***

~~Зачёркнутый~~:
\`~~текст~~\` → ~~текст~~

## Заголовки

\`\`\`
# H1
## H2
### H3
#### H4
##### H5
###### H6
\`\`\`

## Горизонтальные линии

\`\`\`
___ или ***
\`\`\`

## Ссылки

Обычная ссылка:
\`[текст](URL)\` → [Обычная ссылка](https://example.com)


Прямая ссылка:
\`<https://example.com>\` → <https://example.com>

## Списки

### Ненумерованные
Ввод:
\`\`\`
- Пункт 1
- Пункт 2
  - Подпункт (2 пробела)
\`\`\`
Результат:
- Пункт 1
- Пункт 2
  - Подпункт (2 пробела)

### Нумерованные
Ввод:
\`\`\`
1. Первый
2. Второй
3. Третий
\`\`\`
Результат:
1. Первый
2. Второй
3. Третий

### Чеклисты
Ввод:
\`\`\`
- [x] Сделано
- [ ] Не сделано
\`\`\`
Результат:
- [x] Сделано
- [ ] Не сделано

## Таблицы

\`\`\`
| Заголовок | Выравнивание | Заголовок |
|-----------|:------------:|----------:|
| Ячейка    | По центру    | Справа    |
| Ячейка    | По центру    | 100       |
\`\`\`

## Прочие элементы

### Сноски
Текст со сноской[^1]

\`Текст со сноской[^1]\`

\`[^1]: Текст сноски\`

[^1]: Пример сноски

### Экранирование
\\*Экранированный символ\\*:
\`\\*текст\\*\` → *текст*

`;
